import axios from "axios";

const axiosClient = axios.create({
  baseURL: "https://gentle-bastion-09058.herokuapp.com/api/",
  headers: { "Access-Control-Allow-Origin": "http://localhost:3000" },
});

export default axiosClient;
